module.exports = "<div class=\"form-control component-multi-linkage-control\"> <div class=multi-drop></div> <div class=refresh>重置</div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/multi-linkage-control/multi-linkage-control.wx.html
// module id = 1962
// module chunks = 50